import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, map, skipWhile } from 'rxjs';
import { selectUserData } from '../state/core.selectors';
import { Roles } from '../../user-admin/roles/models/Roles';
import { NavigationUtils } from '../../shared/utils/navigation-utils';

@Injectable({
    providedIn: 'root'
})
export class AuthUserGuardService {
    constructor(private readonly store: Store, private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.checkAccess(route);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
        return this.checkAccess(childRoute);
    }

    checkAccess(route: ActivatedRouteSnapshot): Observable<boolean> {
        const currentRoute = route.routeConfig?.path;

        return this.store.select(selectUserData).pipe(
            skipWhile(user => user == null),
            map(user => {
                if (currentRoute === 'welcome' && user?.basicRole.roleKey !== Roles.CREATE_USER) {
                    NavigationUtils.openUrl('/');
                    return false;
                }

                if (currentRoute !== 'welcome' && user?.basicRole.roleKey === Roles.CREATE_USER) {
                    this.router.navigate(['/welcome']);
                    return false;
                }

                if (currentRoute === 'archive-search' && user?.basicRole.roleKey !== Roles.SYSTEM_ADMIN) {
                    this.router.navigate(['/analysis-search']);
                    return false;
                }

                return true;
            })
        );
    }
}

export const AuthUserGuard: CanActivateFn = (next: ActivatedRouteSnapshot): Observable<boolean> => inject(AuthUserGuardService).canActivate(next);

export const AuthUserGuardChild: CanActivateChildFn = (next: ActivatedRouteSnapshot): Observable<boolean> =>
    inject(AuthUserGuardService).canActivateChild(next);
